import { gettext } from './../gettext-extract-util';
import { ASSET_TYPE_ATTRIBUTE, ASSET_TYPE_VALUES } from '../../api/assetTypeAttribute';

export const ROOT_SEARCH_STATE = 'search';

export const COMMUNICATED_TAG = 'lastcommunicated';
export const NOT_COMMUNICATED_TAG = 'notcommunicated';
export const NEVER_COMMUNICATED_TAG = 'nevercommunicated';
/**
 * Adapt separated search facets into the shape expected by our repository / API
 * layer.
 * @param {*} searchState Application search state object
 */
export const adaptFacets = (searchState) => {
  const { alerts, maintenance, lastCommunicated, securityGroups, lastSeen } = searchState;
  return {
    alerts,
    maintenance,
    lastCommunicated,
    securityGroups,
    lastSeen,
  };
};

class SearchStateModel {
  constructor() {
    this.inProgress = false;
    this.error = '';
    this.query = [];
    this.filters = [];
    this.cursor = 0;
    this.limit = 50;
    this.since = 0;
    this.bounds = [];
    this.shareKey = '';
    this.initial = true;
    this.securityGroups = [];
    this.alerts = [
      {
        label: gettext('Low'),
        id: 'low',
        icon_color: 'color-low-priority',
        _selected: false,
        title: gettext('Low alert'),
      },
      {
        label: gettext('Medium'),
        id: 'medium',
        icon_color: 'color-medium-priority',
        _selected: false,
        title: gettext('Medium alert'),
      },
      {
        label: gettext('High'),
        id: 'high',
        icon_color: 'color-high-priority',
        _selected: false,
        title: gettext('High alert'),
      },
    ];

    this.maintenance = [
      {
        label: gettext('Upcoming'),
        id: 'upcoming',
        icon_color: 'color-low-priority',
        _selected: false,
        title: gettext('Upcoming maintenance'),
      },
      {
        label: gettext('Due'),
        id: 'due',
        icon_color: 'color-high-priority',
        _selected: false,
        title: gettext('Due maintenance'),
      },
    ];

    this.lastCommunicated = [
      {
        group: gettext('Communicated'),
        label: gettext('within 24h'),
        id: 'lc-24h',
        range: { tag: '24h' },
        tag: COMMUNICATED_TAG,
        _selected: false,
      },
      {
        group: gettext('Communicated'),
        label: gettext('within 7d'),
        id: 'lc-7d',
        range: { tag: '7d' },
        tag: COMMUNICATED_TAG,
        _selected: false,
      },
      {
        group: gettext('Communicated'),
        label: gettext('within 30d'),
        id: 'lc-30d',
        range: { tag: '30d' },
        tag: COMMUNICATED_TAG,
        _selected: false,
      },

      {
        group: gettext('Not Communicated'),
        label: gettext('within 24h'),
        id: 'nc-24h',
        range: { tag: '24h' },
        tag: NOT_COMMUNICATED_TAG,
        _selected: false,
      },
      {
        group: gettext('Not Communicated'),
        label: gettext('within 7d'),
        id: 'nc-7d',
        range: { tag: '7d' },
        tag: NOT_COMMUNICATED_TAG,
        _selected: false,
      },
      {
        group: gettext('Not Communicated'),
        label: gettext('within 30d'),
        id: 'nc-30d',
        range: { tag: '30d' },
        tag: NOT_COMMUNICATED_TAG,
        _selected: false,
      },
      {
        group: gettext('Not Communicated'),
        label: gettext('ever'),
        id: 'nc-ever',
        range: { tag: { never: true } },
        tag: NEVER_COMMUNICATED_TAG,
        _selected: false,
      },
    ];
    this.tagFilters = {};
    this.modes = [];
    this.includes = [];
    this.prefilter = {
      queries: ['*'],
      index: 'equipment',
    };
    this.sort = { name: 'name.raw', direction: 'asc' };
    this.exportInProgress = false;
    this.accounts = [];
    this.lastSeen = [];
  }
}

export const INITIAL_STATE = new SearchStateModel();

//array of paths to keys need to be saved
export const SearchWhiteListKeys = [[ROOT_SEARCH_STATE]];

//array of paths to keys need to be excluded from the ones that need to be saved
export const SearchBlackListKeys = [
  [ROOT_SEARCH_STATE, 'inProgress'],
  [ROOT_SEARCH_STATE, 'error'],
  [ROOT_SEARCH_STATE, 'cursor'],
  [ROOT_SEARCH_STATE, 'since'],
  [ROOT_SEARCH_STATE, 'initial'],
];
